<template>
  <div id="projects">
    <h1>Projects</h1>
    <pre class="text">
    The following projects and repos represent a collection of all my (Dylan
    Callaghan's) projects. Feel free to have a look through them. If you would
    like to contribute, please contact me.

    </pre>
    <project title="Scripts"
    link="https://github.com/DCallaz/scripts"
    blurb="A collection of the various scripts and settings I use to
    make my workflow and environment easier. The repository can also be cloned
    and set up easily within seconds on any new machine."/>
    <project title="Redtongue"
    link="https://github.com/DCallaz/redtongue"
    blurb="A simplistic WiFi transfer protocol written in java. The intention of
    this application is to be used on all devices to be able to transfer files
    from one device to another seemlessly and securely."/>
    <project title="Redtongue (Android)"
    link="https://github.com/DCallaz/RedTongue_Android"
    blurb="The android version of RedTongue. This is completely compatible with
    the desktop version, and is intended to be used to transfer files from an
    android device to desktop."/>
    <project title="This website"
    link="https://github.com/DCallaz/dylancallaghan"
    blurb="The repo for this website. The website is compiled and deployed to
    this domain every time something is pushed to master."/>
  </div>
</template>

<script>
import project from './project'
export default {
  name: 'projects',
  components: {
    project
  }
}
</script>



// WEBPACK FOOTER //
// src/components/projects.vue